<span class="ipm-sparkle" *ngFor="let spark of sparkles; trackBy: trackByIndex" aria-hidden="true"
    [style.left.%]="spark.left" [style.bottom.%]="spark.bottom"
    [style.animation-delay.s]="spark.delay" [style.animation-duration.s]="spark.duration"
    [style.font-size.px]="spark.size" [style.color]="spark.color">{{spark.glyph}}</span>
